import axios from 'axios';

export default () =>
  axios(`${process.env.FRONTEND_ENDPOINT}/api/auth/logout`).then(res => {
    if (res.status !== 200) {
      throw new Error('Something went wrong, please try again');
    }
    return res;
  });
